import { API_ORIGIN } from '@/lib/config'

/** Đường dẫn tương đối từ backend → URL tuyệt đối để trình duyệt mở được. */
export function assetUrl(u?: string | null): string | undefined {
  if (!u) return undefined
  if (/^https?:\/\//i.test(u) || u.startsWith('data:')) return u
  return `${API_ORIGIN}${u.startsWith('/') ? '' : '/'}${u}`
}
